import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import { mostrarPrestamoById} from '../../redux/reducers/prestamosReducer';
import {ajustarCapitalPrestamo, getFechaHoraActual} from "../../services";
import {Dialog, DialogActions, DialogContent, Button, Grid, TextField, Theme, Box} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import TopBarDialog from "../../components/topBar/TopBarDialog";
import {LoadingProgress,MostrarError} from "../../components";
import {DateInput, TextFieldCurrency} from "../../components/CustomTextField";
import Strings from "../../assets/strings";
import SelectCaja from "../../components/selects/SelectCaja";
import {formatPeso} from "../../helpers";
import {SelectEnum} from "../../components/selects";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IPrestamoDetalle} from "../../redux/types/IPrestamo";
import {IPago} from "../../redux/types/IPago";
const useStyles = makeStyles((theme: Theme) => ({
    root: {
        boxShadow: "none",
        [theme.breakpoints.up('sm')]: {
            maxWidth:510,
            margin:"0px auto",
        },
    },
    content:{
        padding:theme.spacing(2),
    }
}));


function AjustarCapitalDialog() {
    const classes = useStyles();
    let dispatch = useAppDispatch();
    const navigate = useNavigate();
    const goBack = () => navigate(-1);
    let cajaIdDefault = useAppSelector(state => state.auth.user?.cajaIdDefault);
    let prestamo = useAppSelector(state => state.prestamos.byId || {} as IPrestamoDetalle);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [state, setState] = useState<IPago>({});
    useEffect(()=>{
        if (prestamo.id) {
            let obj = {
                capital: 0,
                fecha: "",
                cajaId:cajaIdDefault,
                concepto: "",
                tipoFormaPago:undefined,
            };
            getFechaHoraActual().then(({data}) => {
                setState(prevState => ({...prevState, ...obj, fecha: data}));
            })
        }
    },[prestamo.id, cajaIdDefault])

    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name,value} = e.target;
        if(name === "fecha") return setState({...state,[name]: value+""+state.fecha?.substr(10)});

        setState({...state,  [name]: value });
    };
    const submit = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        ajustarCapitalPrestamo({
            id: prestamo.id!,
            monto: state.capital ? +state.capital :0,
            fecha: state.fecha,
            comentario: state.concepto,
            tipoFormaPago: state.tipoFormaPago ? +state.tipoFormaPago : undefined,
            cajaId: state.cajaId,
        }).then(()=>{
            setLoading(false);
            dispatch(mostrarPrestamoById(prestamo.id!));
            goBack()
        }).catch(error=>{
            setError(error.response);
            setLoading(false)
        })
    };

    return (
        <Dialog className={classes.root} open={true} onClose={goBack} fullWidth maxWidth={"sm"}>
            <TopBarDialog title="Ajustar Capital" onClose={goBack} nofullScreen/>
            <MostrarError errors={error}/>
            <form onSubmit={submit}>
              <DialogContent className={classes.content}>
                  {loading && <LoadingProgress vh={false} />}
                  <Box sx={{
                      background: "#e6e6e6",
                      padding: "11px",
                      textAlign: "center",
                      fontSize: "large",
                      marginBottom:2
                  }}>
                      { formatPeso(((prestamo.capitalActual??0) + +(state.capital??0)))}
                      <Box fontSize={12}>{Strings.capitalActual}</Box>
                  </Box>
                  <Grid container spacing={3}>

                    <Grid item xs={12} sm={6}>
                        <TextFieldCurrency
                            name="capital"
                            label={Strings.monto}
                            value={state.capital}
                            onChange={handleChange}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DateInput
                            name={"fecha"}
                            value={state.fecha}
                            label={Strings.fecha}
                            onChange={handleChange}
                            fullWidth native={undefined} clearable={undefined} openTo={undefined} views={undefined}
                            quincenalFijo={undefined}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectCaja
                            name="cajaId"
                            label={Strings.caja}
                            value={state.cajaId}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            name="concepto"
                            label={Strings.concepto}
                            value={state.concepto}
                            fullWidth
                            onChange={handleChange}
                            inputProps={{maxLength: 100}}

                        />
                    </Grid>
                      <Grid item xs={12}>
                          <SelectEnum label={Strings.tipoFormaPago} group="tiposFormasPago" name="tipoFormaPago" required value={state.tipoFormaPago} onChange={handleChange}/>
                      </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                  <Button type={"button"} color={"warning"} variant={"text"} onClick={goBack}>
                      {Strings.cancelar}
                  </Button>
                  <Button type="submit" color="primary" disabled={!!loading}  variant={"outlined"}>
                      Guardar
                  </Button>

              </DialogActions>
            </form>
        </Dialog>
    );
}

export default AjustarCapitalDialog;



